import { EFFECT_TYPES } from '../../config/effectTypes';

/**
 * How many edges carry a type somebody actually chose. Every other edge is
 * drawn as a muted "johtaa" — true, but the map's assumption rather than a
 * decision, so it does not count here. Two edge sets: the spine
 * (submissions.effect_type) and borrowed parents
 * (pathway_connections.connection_type).
 */
export function summariseEdges(pathways, connections) {
  const spine = pathways.filter((p) => p.parentId || p.parent_id);
  // A scenario's edges to its variables are structure, not consequences,
  // and are never typed; they do not count.
  const structural = (p) => p.type === 'scenario_root' || p.type === 'scenario_variable';
  const edges = spine.filter((p) => !structural(p));
  const humanSpine = edges.filter((p) => EFFECT_TYPES[p.effectType] && p.effectTypeSource !== 'ai').length;
  const aiSpine = edges.filter((p) => EFFECT_TYPES[p.effectType] && p.effectTypeSource === 'ai').length;
  const typedLinks = connections.filter((c) => EFFECT_TYPES[c.type]).length;
  return {
    typed: humanSpine + typedLinks,
    aiTyped: aiSpine,
    total: edges.length + connections.length,
  };
}
